module.exports = __webpack_public_path__ + "img/facebook.ecf1500c.png";